module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/renee-a80a9ac083f7601e6eceef5df5694c30.jpg";